module.exports = __webpack_public_path__ + "img/twich-footer.5b26723d.svg";